module.exports = __webpack_public_path__ + "img/ics_o_edit.a0a8899b.svg";